<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-select :items="orderDateType" item-value="value" item-text="name" v-model="selectedDateType" label="Chọn ngày"></v-select>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-btn @click="filter_data(0)" color="#a77800" outlined>Lọc dữ liệu</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-select :items="orderStatus" item-value="value" item-text="name" v-model="selectedStatus" label="Trạng thái cuối"></v-select>
                </v-flex>
                <v-flex lg6 md12 sm12 pr-6>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-btn @click="filter_data(1)" color="#a77800" outlined>Lọc dữ liệu</v-btn>
                </v-flex>
             </v-layout>    
        </v-flex>    
        <!-- <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                    <highcharts :options="chartOptions"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex> -->
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-toolbar flat color="blue-grey" dark>
                    <v-toolbar-title>Giảm trừ doanh thu</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12>
                            <v-data-table :headers="loss_headers"  hide-default-footer disable-pagination :sortable="false" :items="loss_items" :loading="loading" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td class="text-end">{{ item.ComplainAmount | currency}}</td>
                                        <td class="text-end">{{ item.CancelAmount | currency}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex lg12>
            <v-card class="mb-8">
                <v-toolbar flat color="blue-grey" dark>
                    <v-toolbar-title>Doanh thu</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12>
                            <v-data-table :headers="headers" hide-default-footer disable-pagination :sortable="false" :items="revenue_total" :loading="loading" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td class="text-end">{{ item.OrderRevenue | currency}}</td>
                                        <td class="text-end">{{ item.FeeWeightRevenue | currency}}</td>
                                        <td class="text-end">{{ item.OtherRevenue | currency}}</td>
                                        <td class="text-end">{{ item.PayRevenue | currency}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex lg12>
            <v-card class="mb-8">
                <v-toolbar flat color="blue-grey" dark>
                    <v-toolbar-title>Doanh thu theo nhân viên</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12>
                            <v-data-table :headers="summary_headers" hide-default-footer disable-pagination :sortable="false" :items="staff_summary" :loading="loading" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>{{item.StaffName}}</td>
                                        <td class="text-end">{{ item.DiffRevenue | currency}}</td>
                                        <td class="text-end">{{ item.OrderRevenue | currency}}</td>
                                        <td class="text-end">{{ item.FeeWeightRevenue | currency}}</td>
                                        <td class="text-end">{{ item.OtherRevenue | currency}}</td>
                                        <td class="text-end">{{ item.TotalRevenue | currency}}</td>
                                    </tr>
                                </template>
                                <template v-slot:body.append v-if="staff_total">
                                    <tr>
                                        <td class="font-weight-bold">TỔNG</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.DiffRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.OrderRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.FeeWeightRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.OtherRevenue | currency }}</td>
                                        <td class="font-weight-bold text-end">{{ staff_total.TotalRevenue | currency }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
// import {Chart} from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment"
export default {
    // components: {
    //     highcharts: Chart 
    // },
    data() {
        return {
            viewName: "bao-cao-doanh-thu",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            orderDateType: [
                {value: 1, name: 'Ngày tạo đơn'},
                {value: 2, name: 'Ngày mua hàng'},
                {value: 3, name: 'Ngày nhập kho TQ'},
                {value: 4, name: 'Ngày xuất kho TQ'},
                {value: 5, name: 'Ngày nhập kho VN'},
                {value: 6, name: 'Ngày xuất kho VN'},
                {value: 7, name: 'Ngày thanh toán'},
                {value: 8, name: 'Ngày hoàn thành'},
            ],
            orderStatus: configs.ORDER_STATUS,
            menuStart: false,
            menuEnd: false,
            selectedDateType: 1,
            selectedStatus: 5,
            loss_headers: [
                {
                text: "Hoàn tiền khiếu nại",
                value: "ComplainAmount",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Hoàn tiền hủy đơn",
                value: "CancelAmount",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }
            ],
            headers: [
                {
                text: "Doanh thu mua hộ",
                value: "OrderRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu vận chuyển",
                value: "FeeWeightRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu DV tăng thêm",
                value: "OtherRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu thanh toán hộ",
                value: "PayRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }
            ],
            summary_headers: [
                {
                text: "Nhân viên",
                value: "StaffName",
                dataType: configs.DATA_TYPE["String"]
                },
                {
                text: "Chênh lệch tiền hàng",
                value: "DiffRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu mua hộ",
                value: "OrderRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu vận chuyển",
                value: "FeeWeightRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu DV tăng thêm",
                value: "OtherRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng doanh thu",
                value: "TotalRevenue",
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }
            ],
        };
    },
    computed: {
        ...mapState({
            loss_items: state => state.report.orderRevenueV2.data.loss_items,
            rev_items: state => state.report.orderRevenueV2.data.rev_items,
            staff_summary: state => state.report.orderRevenueV2.summary,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        revenue_total() {
            var ret = {
                'OrderRevenue': _.sumBy(this.rev_items, 'OrderRevenue'),
                'FeeWeightRevenue': _.sumBy(this.rev_items, 'FeeWeightRevenue'),
                'OtherRevenue': _.sumBy(this.rev_items, 'OtherRevenue'),
                'PayRevenue': _.sumBy(this.rev_items, 'PayRevenue')
            };
            return [ret];
        },
        staff_total() {
            var ret = {
                'DiffRevenue': _.sumBy(this.staff_summary, 'DiffRevenue'),
                'FeeWeightRevenue': _.sumBy(this.staff_summary, 'FeeWeightRevenue'),
                'OrderRevenue': _.sumBy(this.staff_summary, 'OrderRevenue'),
                'OtherRevenue': _.sumBy(this.staff_summary, 'OtherRevenue'),
                'TotalRevenue': _.sumBy(this.staff_summary, 'TotalRevenue'),
            };
            return ret;
        },
        // chartOptions() {
        //     var dataChart =  _.sortBy(this.items,'ReportMonth');
        //     var ret = {
        //         chart: { type: 'line' },
        //         title: { text: 'Doanh thu' },
        //         credits: { enabled: false },
        //         tooltip: {shared: true},
        //         xAxis: {
        //             categories: _.map(dataChart, function(x) {return x.ReportMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")})
        //         },
        //         yAxis: {
        //             title: {
        //                 text: 'Tổng tiền (VNĐ)'
        //             }
        //         },
        //         plotOptions: {
        //             line: {
        //                 dataLabels: {
        //                     enabled: true
        //                 }
        //             }
        //         },
        //         series: [
        //             { name: 'Mua hộ', data: _.map(dataChart, 'OrderRevenue') },
        //             { name: 'Ký gửi', data: _.map(dataChart, 'DepositRevenue') },
        //             { name: 'TT hộ', data: _.map(dataChart, 'PayRevenue') },
        //             { name: 'Hoàn khách', data: _.map(dataChart, 'ComplainAmount') },
        //             { name: 'Tổng giao dịch', data: _.map(dataChart, 'TotalRevenue') },
        //         ]
        //     };

        //     return ret;
        // }
    },
    methods: {
        filter_data: function (type) {
            var param = {
                filterType: type,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                orderStatus: this.selectedStatus,
                dateType: this.selectedDateType
            };
            this.$store.dispatch("report/getOrderRevenueV2Report", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>